import React from 'react';
import { Product } from 'bootstrap/data/product/Product';
import Alert from 'components/error/Error';
import { usePaymentsLogic } from 'subscription/recurly/components/paymentpicker/PaymentsPicker.hook';
import { SuccessPaymentProps } from 'subscription/recurly/Recurly.types';
import { PaymentsAccordion } from 'subscription/components/Payments/accordion/PaymentsAccordion';
import { isGiftFlow, isInviteFlow } from 'useFeatures';
import { PaymentMethods } from 'subscription/components/Payments/Payments.types';
import { Picker } from 'subscription/components/picker/Picker';

type Props = {
  product: Product;
  darkTheme?: boolean;
  isPaypalLoading?: boolean;
  translation?: any;
  children?: JSX.Element | JSX.Element[];
  onSuccess: (params: SuccessPaymentProps) => void;
  onError: (message: string) => void;
};

export const PaymentsPicker = ({
  product,
  darkTheme = false,
  onSuccess,
  onError,
  translation,
  children,
}: Props) => {
  const {
    pickerOptions,
    errorMessage,
    isPaypalLoading,
    isPaypalReady,
    handlePaymentMethodChange,
    setErrorMessage,
  } = usePaymentsLogic({
    product,
    darkTheme,
    onSuccess,
    onError,
  });

  return (
    <>
      <Alert
        visible={!!errorMessage}
        error={errorMessage}
        onClose={() => setErrorMessage('')}
      />
      {isGiftFlow() || isInviteFlow() ? (
        <>
          <Picker
            options={pickerOptions}
            currentOption={PaymentMethods.Card}
            darkTheme={darkTheme}
            onChange={handlePaymentMethodChange}
          />
          {children}
        </>
      ) : (
        <PaymentsAccordion
          product={product}
          options={pickerOptions}
          translation={translation}
          isPaypalLoading={isPaypalLoading && !isPaypalReady}
          onSuccess={onSuccess}
          onError={onError}
        >
          {children}
        </PaymentsAccordion>
      )}
    </>
  );
};
